import SuppliesApi from '../../../../API/shipment/supplies-api';
import { PopUp, Row } from '../../../../components/Basic/Blocks';
import { Button } from '../../../../components/Basic/Buttons';
import { H2 } from '../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../../constans';
import { getDate } from '../../../../utils';
import styles from './styles.module.scss';

const DeleteSupplyPopUp = ({ supply = {}, close = () => { } }) => {
  const clickDelete = async () => {
    await SuppliesApi.deleteSupply({ data: { supplyId: supply.id } }).then(() => {
      close();
    });
  };

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2>Вы уверены что хотите удалить поставку {supply.market}/{supply.shop} ({getDate(supply.time_scheduled)})?</H2>

      <Row style={{ marginTop: '30px' }}>
        <Button type={TYPE_BUTTONS.BLUE} style={{ marginRight: '20px' }} onClick={() => clickDelete()}>
          Удалить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default DeleteSupplyPopUp;
